import { SVGProps } from 'react';
import { cn } from '@/Domain/utils/cn';

export const Spinner = ({ className, ...props }: SVGProps<any>) => (
  <svg
    role="status"
    data-testid="spinner"
    className={cn('h-5 w-5 animate-spin text-foreground', className)}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
    ></path>
  </svg>
);
